export default __webpack_public_path__ + "static/banner-top-cars-under-40k-47b4cdd92df7d882993900aa1ba86a32.jpg";